import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import ToggleSwitch from '@/components/UI/ToggleSwitch';
import { doNothing } from '@/utils/utils';
import { BtnOneLineBlue } from '@/components/buttons/BtnOneLineBlue';
import { useCookieConsentStore } from '@/store/zustand/cookie-consent-store';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { AbsoluteLink } from '@/components/AbsoluteLink';
import { BaseModalProps } from '@/features/modal/types';

export const CookiesModal = ({ closeModal }: BaseModalProps): JSX.Element => {
  const intl = useIntl();
  const [allowPerformance, setAllowPerformance] = useState(true);
  const acceptCookies = useCookieConsentStore(state => state.acceptCookies);
  const absoluteNavigate = useAbsoluteNavigate();
  const savePreferences = () => {
    acceptCookies(allowPerformance);
    closeModal();
  };

  const openCookiePolicy = () => {
    absoluteNavigate('/privacy-policy');
    closeModal();
  };

  return (
    <ModalLayout close={closeModal}>
      <div className="w-full max-w-sm">
        <div className="mb-4 text-lg font-bold">
          <FormattedMessage id="cookies.modal.title" />
        </div>
        <div className="flex flex-col gap-4">
          <ToggleSwitch
            label={intl.formatMessage({ id: 'cookies.modal.essential' })}
            labelClass="font-bold"
            checked={true}
            disabled={true}
            onChange={doNothing}
          />
          <div className="mb-4 text-sm">
            {intl.formatMessage({ id: 'cookies.modal.essential.hint' })}
          </div>
          <ToggleSwitch
            label={intl.formatMessage({ id: 'cookies.modal.performance' })}
            labelClass="font-bold"
            checked={allowPerformance}
            disabled={false}
            onChange={setAllowPerformance}
          />
          <div className="text-sm">
            <FormattedMessage id="cookies.modal.performance.hint" />
          </div>
        </div>
        <div className="mt-8 text-sm">
          <FormattedMessage
            id="cookies.modal.performance.link"
            values={{
              a: str => (
                <AbsoluteLink to="/privacy-policy" onClick={openCookiePolicy} className="underline">
                  {str}
                </AbsoluteLink>
              ),
            }}
          />
        </div>
        <div className="mt-12">
          <BtnOneLineBlue
            onClickHandler={savePreferences}
            isLoading={false}
            text={intl.formatMessage({ id: 'cookies.accept' })}
          />
        </div>
      </div>
    </ModalLayout>
  );
};
